export default function px2vw(value = 0, is_mobile = false) {
  if (is_mobile) {
    const designWidth = parseFloat(import.meta.env.VITE_DESIGN_WIDTH) || 375;
    const result = (value / designWidth) * 100;
    return `${parseFloat(result.toFixed(2))}vw`;
  } else {
    return `${value}px`
  }
}
